import React from "react"
const LocaleContext = React.createContext<undefined | string>(undefined)
export const LocaleProvider = LocaleContext.Provider
export default LocaleContext
